import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      paths: [{
        name: "Профиль",
        path: "/rol-shop/profile"
      }]
    };
  },
  methods: {
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setPaths(vm.paths);
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (from.name === 'History' || from.name === 'Favorites' || from.name === 'Address') {
      this.setPaths(this.paths);
      next();
    } else {
      next();
    }
  },
  mounted() {}
};